import React from 'react';
import { BodyText, Column, Row } from '../../atoms';
import { ColumnValue, RowWrapper } from './SummaryTable.styles';
import { SummaryTableRows } from './types';

export type Props = {
  /**
   * Rows configuration
   */
  rows: SummaryTableRows;
  /**
   * Column spans defining how much space in a grid a given column should take
   */
  columnSpans: number[];
};

const SummaryTable = ({ rows, columnSpans }: Props) => (
  <>
    {rows.map((row, index) => (
      <RowWrapper key={index} paddingTop={3} paddingBottom={3}>
        <Row rowGap={0}>
          {row.map((cell, index) => (
            <Column span={columnSpans[index]} key={cell.value + '_' + index}>
              <BodyText
                textAlign={cell.textAlign}
                fontWeight={cell.fontWeight}
                color={cell.color}
              >
                <ColumnValue fontSize={cell.fontSize}>{cell.value}</ColumnValue>
              </BodyText>
            </Column>
          ))}
        </Row>
      </RowWrapper>
    ))}
  </>
);

export default SummaryTable;
